import {useAccount} from "../../../administration/users/AccountProvider";
import {useLocation} from "react-router";
import React, {useEffect, useState} from "react";
import { Alert } from '@mui/material';
import {parse} from "query-string";
import {useTranslation} from "react-i18next";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid/Grid";
import {ApplicationCard} from "../../../account/ApplicationCard";
import {formatUser} from "../../../administration/users/User";
import {getVisibleApplicationRoles} from "../../../administration/users/ApplicationRoles";

const applicationNameParam = 'applicationName';

export function NoApplicationAccessPage() {
  const account = useAccount();
  const location = useLocation();
  const {t} = useTranslation();
  const [application, setApplication] = useState('')

  useEffect(() => {
    const parsed = parse(location.search);
    if (parsed[applicationNameParam]) {
      setApplication(parsed[applicationNameParam] as string)
    }
  }, [location]);

  return (
    <>
      <Alert color={'error'}>{t('NoApplicationAccessPage.noAccessToApplicationMsg', {
        userName: formatUser(account),
        applicationName: t('Applications.' + application)
      })}</Alert>
      <Typography style={{marginTop: '24px'}}>{t('NoApplicationAccessPage.applicationAccessTitle')}:</Typography>
      <Grid container={true} style={{marginTop: '24px'}}>
        {getVisibleApplicationRoles(account).map(applicationRole =>
          <Grid key={applicationRole.applicationName} item={true} xs={12} sm={6} lg={3} xl={1}>
            <ApplicationCard applicationName={applicationRole.applicationName} role={applicationRole.role}/>
          </Grid>
        )}
      </Grid>
    </>
  )
}

